import { createFileRoute } from '@tanstack/react-router'

import { NnppOrderDetailPage } from '@/src/pages/nnpp/orders/NnppOrderDetailPage'

export const Route = createFileRoute('/nnpp/orders/$orderId')({
  component: NnppOrderDetailRoute,
  staticData: { layout: { enableScrolling: true, showSearchBar: false } },
})

function NnppOrderDetailRoute() {
  const { orderId } = Route.useParams()
  const { orgId } = Route.useSearch()
  return <NnppOrderDetailPage organizationId={orgId} orderId={orderId} />
}
